import { IconNames } from '@blueprintjs/icons';
import { Icon, IssueDetail } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

export const LabelWithIssue = ({ text, issues = undefined, issueType }) =>
    issues?.includes(issueType) ? (
        <span style={{ display: 'flex' }}>
            {text}
            <Icon
                icon={IconNames.WARNING_SIGN}
                size={12}
                intent={Icon.Intent.WARNING}
                title="Issues"
                tooltipContent={IssueDetail.IssueTypeMap[issueType]}
                className="padding__left--x-small"
            />
        </span>
    ) : (
        text
    );

LabelWithIssue.propTypes = {
    text: PropTypes.string.isRequired,
    issues: PropTypes.arrayOf(PropTypes.string),
    issueType: PropTypes.string.isRequired,
};
